
import { SingleRow } from "./SingleRow";

export const Table = ({props}: any) => {
  return (
    <div className="main-section">
      {props ? (
        <table className="table">
          <thead>
            <tr>
              <th>User Id</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Purchase Date</th>
              <th>Plan End Date</th>
              <th>Plan Name</th>
              <th>Pro Module Name</th>
            </tr>
          </thead>
          <tbody>
            {props &&
              props.length > 0 &&
              props.map((el: any) => (
                <SingleRow key={el._id} props={el} />
              ))}
          </tbody>
        </table>
      ) : (
        <h1 className="no-data">No Data Found</h1>
      )}
    </div>
  );
};
